module.exports = "https://preview.prokomcdn.no/june/cdn-resources/client-grunt/lyngdal/inter-v2/prod/images/open_in_new.svg";